import axios from "axios";
import Config from "src/config";

const v2_actionChatInternoChats = (clienteId, usuarioId) => {
    return axios({
        method: "get",
        url: `${Config.dev ? Config.url_dev : Config.urlBackend}/api/v2/chat-internal/${clienteId}/${usuarioId}/chats`
    });
};
export default v2_actionChatInternoChats;
